import React from 'react';
import styled, { css } from 'styled-components';
import { ColorNordicGrey1, Spacing12 } from 'autogen/design-tokens/tokens';
import useDropdown from 'components/dropdown/hooks/useDropdown';
import SelectButton from 'components/shared/inputs/select/components/SelectButton';
import type { ChanelProductVariants, Option } from '../../shared/types';

const StyledDropdownButton = styled(SelectButton)<{ isVisible: boolean }>`
    width: 100%;
    border-radius: 0;

    &,
    &:hover,
    &:focus {
        box-shadow: none;
        border-color: ${ColorNordicGrey1};
    }

    ${({ isVisible }) =>
        isVisible &&
        css`
            &,
            &:hover,
            &:focus {
                border-bottom-color: transparent;
            }
        `};
`;

const DropdownButtonInner = styled.div`
    display: flex;
    align-items: center;
`;

const ColorSquare = styled.div<Pick<Option, 'color'>>`
    width: 20px;
    height: 20px;
    margin-right: ${Spacing12};
    background-color: ${({ color }) => color};
`;

type ChanelDropdownButtonProps = Pick<ChanelProductVariants, 'displayColorSwatches'> & {
    selectedOption: Option;
};

export const ChanelDropdownButton = React.forwardRef<any, ChanelDropdownButtonProps>((props, ref) => {
    const { selectedOption, displayColorSwatches } = props;
    const { isVisible } = useDropdown();

    return (
        <StyledDropdownButton ref={ref} isVisible={isVisible}>
            <DropdownButtonInner>
                {displayColorSwatches && <ColorSquare color={selectedOption.color} />}
                {selectedOption.label}
            </DropdownButtonInner>
        </StyledDropdownButton>
    );
});

export default ChanelDropdownButton;
